import React from 'react'
import { ContainerContent, RowLine } from './styles'

export interface RowContentPartProps {
  isFilled: boolean
  isFull: boolean
  children?: React.ReactNode
}

export const RowContentPartRef = (props: RowContentPartProps, ref: React.ForwardedRef<HTMLDivElement>): JSX.Element => {
  const { isFilled, isFull, children } = props

  return (
    <ContainerContent ref={ref}>
      <RowLine data-testid="RowLine" isFilled={isFilled} isFull={isFull} />
      {children}
    </ContainerContent>
  )
}

export const RowContentPart = React.forwardRef(RowContentPartRef)
